import React from "react";
import { ComponentDetailsEPDGroupOUT, InventoryEPDGroupOUT } from "api-client";
import { searchStore } from "features/ProductSearch/SearchStore";
import { createEpdsList } from "features/MappingEditor/utils";
import DatasetView, { EPDGroup } from "features/ProductSearch/DatasetView";

const ProductDetails = ({
  epdGroupsData,
}: {
  epdGroupsData?: InventoryEPDGroupOUT[] | ComponentDetailsEPDGroupOUT[];
}) => {
  const [epdGroups, setEpdGroups] = React.useState<EPDGroup[] | undefined>();

  React.useEffect(() => {
    if (!epdGroupsData) return;

    const preparedData = epdGroupsData.map((group) => {
      const epdsList = createEpdsList(group);
      return {
        epds: epdsList,
        certifications: group.certifications || [],
        conformity: group.conformity,
        selectedGroupID:
          group.id === searchStore.currentDetailNode?.selected_epd_group_id,
        health_checked: group.health_checked,
      };
    });

    setEpdGroups(preparedData);
  }, [epdGroupsData]);

  return epdGroups?.map((item: EPDGroup, index) => (
    <DatasetView
      key={index}
      epdGroup={item}
      referenceUnitID={searchStore.currentDetailNode?.reference_unit}
    />
  ));
};

export default ProductDetails;
